import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { resolveLandingPath } from "@/lib/landing";
import { Loader2 } from "lucide-react";

export default function SsoComplete() {
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        await checkAuth();
        // Role-aware landing identical to local login: board-only -> Forum View.
        const dest = await resolveLandingPath();
        navigate(dest, { replace: true });
      } catch {
        navigate("/my-work", { replace: true });
      }
    })();
  }, [navigate, checkAuth]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg text-slate-500 gap-2" data-testid="sso-complete">
      <Loader2 className="h-5 w-5 animate-spin" /> Completing sign-in…
    </div>
  );
}
